/* @flow */

import React from 'react';
import styled from 'styled-components';
import { FlexBox } from './FlexBox';

import Icon from './Icon';

const StyledMessage = styled(FlexBox)`
  background-color: ${({ theme }) => theme.formsbg};
  color: ${({ theme }) => theme.fontColor};
  flex: 1 0 100%;
  align-items: center;
  justify-content: center;
  height: 30px;
  line-height: 30px;
  top: 0;
  position: relative;
`;

const StyledIcon = styled(Icon)`
  padding-right: .2em;
`;

export type Props = {
  message: string,
  pro?: boolean,
};

const EmptyResult = (props: Props) => {
  const { message, pro } = props;

  return (
    <StyledMessage>
      { pro ? <StyledIcon type="nodata" size="16" /> : null }
      {message}
    </StyledMessage>
  );
};

EmptyResult.defaultProps = {
  pro: false,
};

export default EmptyResult;
